import type { InjectionKey } from 'vue'

export const chromaticHue: InjectionKey<number> = Symbol('@proj-airi/chromatic-hue')
